// Whether the wizard should start a login from the `id` query param. It waits
// for the endpoint, whose customer the id must belong to, and does not start
// another one while an id login is pending: the wizard remounts while the
// endpoint loads.
export const shouldStartAuthByUserId = ({
  endpointLoaded,
  pendingUserIdAuth,
}: {
  endpointLoaded: boolean;
  pendingUserIdAuth: boolean;
}): boolean => endpointLoaded && !pendingUserIdAuth;

// Whether a looked-up identifier belongs to the endpoint's customer
export const isIdentifierOfCustomer = (
  identifierCustomerId: string | undefined,
  endpointCustomerId: string
): boolean =>
  !!identifierCustomerId && identifierCustomerId === endpointCustomerId;

// How long the email step waits for a login started from the `id` query param
// before the Pro enters their email instead
export const USER_ID_AUTH_TIMEOUT_MS = 20000;
